import api from "./api";

export default {
    async getAll(){
        return api.get("/configuracoes/static-data")
    },
}
